<template lang="pug">
  v-container(fluid)
    h1 Bible Study Live
</template>

<script>
export default {};
</script>

<style lang="stylus" scoped></style>
